<template>
  <div>
    <Modal :visible="visible" @cancel="handleClose" :size="size">
      <div class="l-container container">
        <div class="box">
          <div class="box-content">
            <div class="menu-content2">
              <SectionContentTitle
                :titleContent="titleContent[1]"
              />
              <div class="content">
                <table class="table-common">
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold">会員ID</div>
                    </td>
                    <td class="data" wovn-ignore>
                      {{ info_person_form.memberId }}
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold">申込者名</div>
                    </td>
                    <td class="data">
                      <span class="mr-1" wovn-ignore>{{ info_person_form.familyName }}</span>
                      <span wovn-ignore>{{ info_person_form.firstName }}</span>
                      様
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold">申込者氏名（カナ）</div>
                    </td>
                    <td class="data">
                      <span class="mr-1" wovn-ignore>{{ info_person_form.familyNameKana }}</span>
                      <span wovn-ignore>{{ info_person_form.firstNameKana }}</span>
                      様
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">ご住所</div>
                      <div class="ml-4 category">必須</div>
                    </td>
                    <td class="data">
                      <div class="member-address">
                        <div v-for="(item, index) in addressMember" :key="`member-address-${index}`" style="margin-bottom:10px;">
                          <div>
                            <a-radio-group v-model="addressSelected" style="display:flex;">
                              <div class="postcode-container">
                                <div>
                                  <a-radio :value="index">ご住所{{index+1}}</a-radio>
                                </div>
                                <div class="postcode-box">
                                  <div class="postcode">
                                    <div class="postcode-item" wovn-ignore>{{item.postalCode}}</div>
                                    <div class="postcode-item" wovn-ignore>
                                      {{item.address1}}
                                      {{item.address2}}
                                    </div>
                                  </div>
                                  <div>
                                    <button class="c-btn btn-white c-btn-pd" @click="handleOpenZipcode(item, index)">
                                      <div class="btn-edit">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" aria-label="edit" role="img" class="c-icon" style="align-self: center;">
                                            <g data-v-abc9f7ae="" fill="#FFF" stroke="#1f2021"><path d="M8 19.9C7.6 20.3 6.8 20.6 6.3 20.6H4C3.5 20.6 3 20.2 3 19.6V17.3C3 16.8 3.3 16 3.7 15.6L16 3.3C16.4 2.9 17 2.9 17.4 3.3L20.3 6.2C20.7 6.6 20.7 7.2 20.3 7.6L8 19.9Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M13.8 5.5L18 9.8" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </g>
                                          </svg>
                                          <span class="">編集</span>
                                      </div>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </a-radio-group>
                          </div>
                        </div>
                        <a class="postcode-container add-postcode" v-if="addressMember && addressMember.length < 4" @click="handleAddAddress">
                          <span class="icon icon-plus-action">
                            <span class="path1"></span>
                            <span class="path2"></span>
                            <span class="path3"></span>
                          </span>
                          <span style="margin-left:3px;">新しい住所を設定する</span>
                        </a>
                      </div>
                      <div class="text-primary font-bold">
                        {{ error_message_addressSelected }}
                      </div>
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">ご連絡先<br />メールアドレス</div>
                    </td>
                    <td class="data">
                      <div class="items-data" style="margin-top: 10px">
                        <div class="content-data">
                          <div class="flex gap-2 elements" wovn-ignore>
                            {{ info_person_form.email }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="label-inp">
                    <td class="flex style-l">
                      <div class="font-bold label-l">ご連絡先電話<br>番号</div>
                    </td>
                    <td class="data">
                      <div class="items-data">
                        <div class="content-data">
                          <div class="flex gap-2 elements" wovn-ignore>
                            {{ info_person_form.tel }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="label-inp"></tr>
                </table>
              </div>
            </div>
            <div class="buttons flex gap-2 justify-center mt-4 mb-4">
              <button class="c-btn btn-white" style="margin-right:20px;" @click="handleClose">
                <span class="text-moblie">キャンセル</span>
              </button>
              <button class="c-btn btn-grey" @click="handleUpdate">
                <span class="text-moblie">申込者情報を変更する</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <ZipcodeInfo 
      :visible="popupZipcodeInfo"
      @cancel="cancelPopupInfo"
      @ok="handlePopupInfo"
      @openAddress="openAddress"
      :prepectureCode="prepectureCode"
      :addressMember="addressMember"
      size="large"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { SectionContentTitle } from '@/components/compound'
import { UPDATE_INFO_DETAIL } from '@/store/modules/bs_app/actions'
import func_utils from '@/mixins/func_utils'
import { Core as YubinBangoCore } from '@/utils/yubinbango-core2/yubinbango-core'
import ZipcodeInfo from '../ZipcodeInfo'


export default {
  name: 'AddressInfo',
  mixins: [func_utils],
  components: {
    SectionContentTitle,
    ZipcodeInfo
  },
  props: ['visible', 'size'],
  data() {
    return {
      customerPlan: null,
      email: 0,
      phone: 0,
      myEmail: '',
      myPhone: 0,
      firstEmail: '',
      secondEmail: '',
      firstTel: '',
      secondTel: '',
      zipCode1: '',
      zipCode2: '',
      prefectures: null,
      cityAddress: null,
      apartment_number: '',
      titleContent: ['お申し込み内容', '申込者情報の変更'],
      error_message: 'メールアドレスを入力してください',
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      error_message_email: null,
      error_message_phone: null,
      error_message_zipcode: null,
      error_message_prefectures: null,
      error_message_cityAddress: null,
      error_message_addressSelected: null,
      hasError: false,
      info_person_form: {
        memberId: '',
        firstName: '',
        familyName: '',
        firstNameKana: '',
        familyNameKana: '',
        apartment_number: '',
        email: '',
        secondEmail: null,
        tel: '',
        secondTel: null
      },
      profileInfo: {},
      totalAdultPeople: 0,
      totalChildren: 0,
      zipcodeError: false,
      isForeign: false,
      popupZipcodeInfo: false,
      addressMember: [],
      addressSelected: null,
      prepectureCode: {}
    }
  },
  mounted() {
    this.customerPlan = this.customerPlanState
    this.mountData()
    this.getProfileInfo()
    this.getMemberAddress()
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.getters, 'planDetail', null))
    },
    customerPlanState() {
      return _.cloneDeep(_.get(this.$store.getters, 'customerPlan', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.info_detail', null))
    },
    getDataBsApp02001() {
      return _.cloneDeep(_.get(this.$store.getters, 'bs_app.bs_app_02_001', null))
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    }
  },
  methods: {
    mountData() {
      const customerInfo = this.getInfoDetail ? this.getInfoDetail : null
      console.log('-------->this.getInfoDetail:', this.getInfoDetail)
      if (customerInfo) {
        this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
        this.info_person_form.firstName = customerInfo.firstName
        this.info_person_form.familyName = customerInfo.familyName
        this.info_person_form.firstNameKana = customerInfo.firstNameKana
        this.info_person_form.familyNameKana = customerInfo.familyNameKana
        this.info_person_form.apartment_number = customerInfo.apartment_number
        this.info_person_form.email = customerInfo.email
        this.info_person_form.secondEmail = customerInfo.secondEmail
        this.info_person_form.tel = customerInfo.tel
        this.info_person_form.secondTel = customerInfo.secondTel
        this.cityAddress = customerInfo.cityAddress
        this.zipCode1 = customerInfo.zipCode1
        this.zipCode2 = customerInfo.zipCode2
        this.prefectures = customerInfo.prefectures
        this.isForeign = customerInfo.isForeign
      }
      this.checkiIsForeign()
    },
    checkiIsForeign() {
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
        }
      }
    },
    getProfileInfo() {
      if (this.getInfoDetail === null) {
        const bs_app_02_001 = this.getDataBsApp02001
        this.profileInfo = bs_app_02_001?.profileInfo
        if (this.profileInfo) {
          const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '')
          this.info_person_form.memberId = _.get(this.userInfo, 'ssoCustomerNo', null)
          this.info_person_form.firstName = this.profileInfo.firstName
          this.info_person_form.familyName = this.profileInfo.familyName
          this.info_person_form.firstNameKana = this.profileInfo.firstNameKana
          this.info_person_form.familyNameKana = this.profileInfo.familyNameKana
          this.info_person_form.email = this.profileInfo.email
          this.info_person_form.secondEmail = this.profileInfo.secondEmail
          this.info_person_form.tel = this.profileInfo.tel
          this.info_person_form.secondTel = this.profileInfo.secondTel
          this.isForeign = this.profileInfo.isForeign
          if (postalCode) {
            this.cityAddress = _.get(this.profileInfo, 'addresses[0].address1', '')
            this.info_person_form.apartment_number = _.get(
              this.profileInfo,
              'addresses[0].address2',
              ''
            )
            this.zipCode1 = postalCode.substring(0, 3)
            this.zipCode2 = postalCode.substring(3, 7)
            this.getProfileMe()
          }
          this.checkiIsForeign()
        }
      }
    },
    getProfileMe() {
      const zipCode = `${this.zipCode1}${this.zipCode2}`
      if (this.zipCode1 && this.zipCode2) {
        new YubinBangoCore(zipCode, (data) => {
          if (data !== null) {
            this.prefectures = data.region ? data.region : ''
          }
        })
      }
    },
    getPrefectures(zipCode){
      let prefectures = ''
      new YubinBangoCore(zipCode, (data) => {
        if (data !== null) {
          prefectures = data.region ? data.region : ''
        }
        return prefectures
      })
    },
    async getMemberAddress(){
      this.addressMember = await this.$repositories('user').getUserAddress()
      console.log('-------->getMemberAddress:', this.addressMember)
    },
    validateZipcodeInput() {
      this.zipCode1 = this.inputAge(this.zipCode1)
      this.zipCode2 = this.inputAge(this.zipCode2)
    },
    async loadLocation() {
      this.validateZipcodeInput()
      this.isForeign = false
      if (this.zipCode1 && this.zipCode2) {
        if (this.zipCode1 === '000' && this.zipCode2 === '0000') {
          this.isForeign = true
          this.hasError = false
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          return
        }
        if (this.zipCode1.length < 3 || this.zipCode2.length < 4) {
          this.zipcodeError = true
          this.hasError = true
          this.prefectures = ''
          this.cityAddress = ''
          this.info_person_form.apartment_number = ''
          this.error_message_zipcode = '郵便番号の形式が正しくありません。'
        }
        const zipCode = `${this.zipCode1}${this.zipCode2}`
        if (zipCode.length > 6) {
          new YubinBangoCore(zipCode, (data) => {
            if (data !== null) {
              if (data.region_id) {
                this.zipcodeError = false
                this.error_message_zipcode = ''
              } else {
                this.zipcodeError = true
                this.hasError = true
                if (zipCode.length > 6) {
                  this.error_message_zipcode =
                    '郵便番号が存在しません。有効な郵便番号を入力してください'
                }
              }
              this.prefectures = data.region ? data.region : ''
              const cityName = _.get(data, 'locality', '')
              // const townName = _.get(data, 'street', '')
              // this.cityAddress = [cityName, townName].filter((val) => val).join('')
              this.cityAddress = cityName + this.cityAddress
              this.info_person_form.apartment_number = ''
            }
            this.checkMessageError()
          })
        } else {
          this.checkMessageError()
        }
      } else {
        this.zipcodeError = false
        this.checkMessageError()
        this.prefectures = ''
        this.cityAddress = ''
      }
    },
    checkMessageError() {
      this.hasError = false
      if (this.prefectures === '') {
        this.hasError = true
        this.error_message_prefectures = '都道府県を入力してください'
      } else {
        this.error_message_prefectures = ''
      }
      if (!this.cityAddress || this.cityAddress.trim() === '') {
        this.hasError = true
        this.error_message_cityAddress = '市区町村・番地を入力してください'
      } else {
        this.error_message_cityAddress = ''
      }
      if (!this.zipcodeError) {
        if (this.zipCode1 === '' || this.zipCode2 === '') {
          this.hasError = true
          this.error_message_zipcode = '郵便番号を入力してください'
        } else {
          this.error_message_zipcode = ''
        }
      }
    },
    updateInfoDetail() {
      const info = {
        memberId: this.info_person_form.memberId,
        firstName: _.get(this.info_person_form, 'firstName', ''),
        familyName: _.get(this.info_person_form, 'familyName', ''),
        firstNameKana: _.get(this.info_person_form, 'firstNameKana', ''),
        familyNameKana: _.get(this.info_person_form, 'familyNameKana', ''),
        zipCode1: this.zipCode1,
        zipCode2: this.zipCode2,
        prefectures: this.prefectures,
        cityAddress: this.cityAddress ? this.cityAddress.trim() : this.cityAddress,
        apartment_number: _.get(this.info_person_form, 'apartment_number', ''),
        info_person: this.info_person,
        email: this.info_person_form.email,
        secondEmail: this.info_person_form.secondEmail,
        tel: this.info_person_form.tel,
        secondTel: this.info_person_form.secondTel,
        myEmail: this.myEmail,
        myPhone: this.myPhone,
        isForeign: this.isForeign
      }
      this.$store.dispatch(UPDATE_INFO_DETAIL, info).then(() => {})
    },
    async handleNext() {
      await this.loadLocation()
      this.updateInfoDetail()
      // eslint-disable-next-line no-empty
      if (!this.hasError) {
        
      }
    },
    handleClose() {
      this.$emit('cancel')
    },
    cancelPopupInfo(){
      this.popupZipcodeInfo = false
    },
    handlePopupInfo() {
      this.popupZipcodeInfo = false
    },
    handleOpenZipcode(code, index){
      let zipcodeInfo = code 
      zipcodeInfo.index = index
      this.prepectureCode = zipcodeInfo
      this.popupZipcodeInfo = true
      this.$emit('cancel')
    },
    handleAddAddress(){
      this.prepectureCode = null
      this.popupZipcodeInfo = true
      this.$emit('cancel')
    },
    openAddress(){
      this.getMemberAddress()
      this.$emit('openAddressInfo')
    },
    handleUpdate(){
      if (this.addressSelected == null) {
        this.error_message_addressSelected = '住所を選択してください'
        return;
      } else {
        this.error_message_addressSelected = ''
      }
      const index = this.addressSelected
      const customerInfo = this.addressMember[index]
      const addressData = {
        customerInfo
      }
      console.log('-------->addressData: Update customerInfo', addressData)
      this.$emit('updateInfoCustomer', addressData)     
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.member-address {

}
</style>
